import { errorNotifier, successNotifier } from "../../../..";
import http, { AUTH_ROUTES } from "../../../../service/api";

export const getAllGroups = async (setGroups, setLoading) => {
  try {
    const data = await http.get(AUTH_ROUTES.GET_ALL_GROUPS);
    console.log('data:',data);
    setGroups(data?.data);
    setLoading(false);
  } catch (e) {
    setLoading(false);
  }
};

//unused
export const createGroups = async (acct_type, payload, setLoading) => {
  try {
    const data = await http.post(AUTH_ROUTES.CREATE_NEW_GROUP(acct_type), payload);
    setLoading(false);
    successNotifier("Group created successfully");
  } catch (e) {
    setLoading(false);
    errorNotifier(e.response?.data?.message);
    throw new Error(e);
  }
};

export const createNewGroup = async (payload, setLoading) => {
  try {
    const data = await http.post(AUTH_ROUTES.CREATE_NEW_GROUP, payload);
    console.log('create-new-group:', payload);
    setLoading(false);
    successNotifier("Group created successfully");
  } catch (e) {
    console.log('create-new-group-error:', e.response?.data?.message);
    setLoading(false);
    errorNotifier(e.response?.data?.message);
    throw new Error(e);
  }
};

export const updateGroup = async (acct_type, payload, groupId, setLoading) => {
  try {
    const data = await http.put(
      AUTH_ROUTES.UPDATE_GROUP(acct_type, groupId),
      payload
    );
    setLoading(false);
    successNotifier("Group updated successfully");
  } catch (e) {
    setLoading(false);
    errorNotifier(e.response?.data?.message);
    throw new Error(e);
  }
};

export const joinGroup = async (invite_link) => {
  return await http.post(AUTH_ROUTES.JOIN_GROUP(invite_link));
};

export const removeGroupMember1 = async (usersToRemove, groupId) => {
  return await http.post(AUTH_ROUTES.REMOVE_GROUP_MEMBERS(usersToRemove, groupId));
};

export const removeGroupMember = async (payload, groupId) => {
  const formData = new FormData()
  return await http.post(AUTH_ROUTES.REMOVE_GROUP_MEMBERS(groupId), payload);
  // try {
  //   const data = await http.post(
  //     AUTH_ROUTES.REMOVE_GROUP_MEMBERS(groupId),
  //     payload
  //   );
  //   // setLoading(false);
  //   // successNotifier("Group updated successfully");
  // } catch (e) {
  //   // setLoading(false);
  //   // errorNotifier(e.response?.data?.message);
  //   throw new Error(e);
  // }
};

///////////////////////////
export const getOtherUsersNotInGroup = async (groupId) => {
  return await http.get(AUTH_ROUTES.GET_GROUP_OTHER_USERS(groupId));
};

export const deleteGroup = async (groupId) => {
  return await http.delete(AUTH_ROUTES.DELETE_GROUP(groupId));
};

export const addSingleUserToGroup = async (groupId, userId) => {
  return await http.get(AUTH_ROUTES.ADD_SINGLE_MEMBER_TO_GROUP(groupId, userId));
};

//change member role, moderator, member
export const changeSingleMemberRole = async (groupId, userId, payload) => {
  return await http.post(AUTH_ROUTES.CHANGE_SINGLE_MEMBER_GROUP_ROLE(groupId, userId), payload);
}

//delete member from group
export const removeMemberFromGroup = async (groupId, userId) => {
  return await http.get(AUTH_ROUTES.REMOVE_GROUP_SINGLE_MEMBER(groupId, userId));
}

export const exitGroup = async (invite_link) => {
  return await http.delete(AUTH_ROUTES.EXIT_GROUP(invite_link));
};

export const paymentSuccess = async (intent_id) => {
  const response = await http.post(AUTH_ROUTES.PAYMENT_SUCCESSFUL(intent_id));
  return response
};

export const checkout = async (groupId, planId) => {
  try {
    const response = await http.post(AUTH_ROUTES.CHECKOUT(groupId, planId));
    return response
  } catch (e) {
    errorNotifier(e.response?.data?.message);
  }
};
